// reactstrap components
import { Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap";

const SpectatorFooter = () => {
  return (
    <footer className="footer">
      <Row className="align-items-center justify-content-xl-between">
        <Col xl="6">
          <div className="copyright text-center text-xl-left text-muted">
            © {new Date().getFullYear()}{" "}
            <a
              className="font-weight-bold ml-1"
              href="https://webworxindia.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              Webworx India
            </a>
          </div>
        </Col>

        <Col xl="6">
          <Nav className="nav-footer justify-content-center justify-content-xl-end">
            <NavItem>
              <NavLink
                href="/spectator/contact-us"
                rel="noopener noreferrer"
              >
                Contact Us
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                href="/spectator/terms-and-condition-and-privacy-policy"
                rel="noopener noreferrer"
              >
                T&C and Privacy Policy
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="/spectator/refund-and-cancellation-policy"
                rel="noopener noreferrer"
              >
                Refund Policy
              </NavLink>
            </NavItem>
          </Nav>
        </Col>
      </Row>
    </footer>
  );
};

export default SpectatorFooter;
